export const RoutesList = {
  HOME: '/',
  REPORTS_LIST: '/reports',
  REPORT_DETAIL: '/report/:reportId',
  CALLBACKS: '/callbacks/*',
  NOT_FOUND: '*',
  INTERNAL_SERVER_ERROR: '/500',
};

export const steps = [
  {
    label: 'Dashboard',
    urlPaths: [RoutesList.HOME],
  },
  {
    label: 'Reports',
    urlPaths: [RoutesList.REPORTS_LIST, RoutesList.REPORT_DETAIL],
  },
];
